import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Route } from '@app/core/route.service';
import { StatisticsComponent } from './statistics.component';

const routes: Routes = Route.withShell([
  { path: 'statistics', component: StatisticsComponent, data: { title: 'Statistics' } }
]);

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class StatisticsRoutingModule { }
